export const PHONE_ERRORS_TEXT = {
    empty: "Укажите номер телефона.",
    international: "Введите номер в международном формате.",
}

export const EMAIL_ERRORS_TEXT = {
    empty: "Введите почту.",
    emptyFromPromoCode: "Сначала введите почту.",
    validation: "Проверьте правильность написания почты.",
}

export const NAME_ERRORS_TEXT = {
    empty: "Укажите ваше имя.",
}

export enum UserFormError {
    email,
    phone,
    name,
    eula,
    offer,
    personalData,
    informedAgreement,
}
